import { useState, useCallback } from 'react';
import { useSearchParams } from '../../wrappers/ReactRouterDom';
import ExternalAuthContext from './ExternalAuthContext';

const ExternalAuthContextProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const [idToken, setIdToken] = useState(() => {
    // Check if tokens are in URL params when component initializes
    return searchParams.get('id_token') || sessionStorage.getItem('id_token') || null;
  });
  const [accessToken, setAccessToken] = useState(() => {
    return searchParams.get('access_token') || sessionStorage.getItem('access_token') || null;
  });

  const isAuthenticated = !!(idToken && accessToken);

  const setTokens = useCallback((newIdToken, newAccessToken) => {
    setIdToken(newIdToken);
    setAccessToken(newAccessToken);
    
    // Store in sessionStorage for persistence across page refreshes
    if (newIdToken) sessionStorage.setItem('id_token', newIdToken);
    if (newAccessToken) sessionStorage.setItem('access_token', newAccessToken);
  }, []);

  const clearTokens = useCallback(() => {
    setIdToken(null);
    setAccessToken(null);
    sessionStorage.removeItem('id_token');
    sessionStorage.removeItem('access_token');
  }, []);

  const redirectToExternalAuth = useCallback(() => {
      
    const authUrl = `${import.meta.env.VITE_YARP_BASE_URL}/bff/login?returnUrl=` + encodeURIComponent(window.location.origin + window.location.pathname + window.location.search);
    window.location.href = authUrl;
  }, []);

  const contextValue = {
    idToken,
    accessToken,
    isAuthenticated,
    setTokens,
    clearTokens,
    redirectToExternalAuth
  };

  return (
    <ExternalAuthContext.Provider value={contextValue}>
      {children}
    </ExternalAuthContext.Provider>
  );
};

export default ExternalAuthContextProvider;